import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.568 5.002a5.75 5.75 0 1 1 8.132 8.132l-6.927 6.927a2.49 2.49 0 0 1-3.27.22 2.6 2.6 0 0 1-.343-.288L3.3 13.134a5.75 5.75 0 0 1 8.132-8.131l.568.567z",
    clipRule: "evenodd"
  }));
}
var IcFavoriteFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteFill));

export { IcFavoriteFill as I };
